import React, { useRef, useState } from "react";
import cn from "classnames";
import styles from "./index.module.scss";
import SectionTitle from "@src/components/SectionTitle";
import useFadeIn from "@src/hooks/useFadeIn";
import { DiscordLink } from "@src/constant/navLinks";
import { ZKAttestationLink, DocsLink } from "@src/constant/navLinks";

const data = [
  {
    ask: "How to participate in the Primus AlphaNet?",
    question: (
      <div className={styles.flexC}>
        <div>
        Primus has upgraded from a centralized setup to a decentralized AlphaNet. The network uses zkTLS and TEE-based attestors to ensure runtime integrity and enhance network security through decentralization.
        </div>
        <div>
        
        To participate, visit <a
          href="https://app.primuslabs.xyz"
          target="_blank"
          className={styles.questionLink}
        >
          https://app.primuslabs.xyz
        </a> and connect your wallet. Please make sure you have installed the latest&nbsp;
        <a
          href={ZKAttestationLink}
          target="_blank"
          className={styles.questionLink}
        >
          Primus Extension
        </a>
        , then follow the instructions to join the available tasks.</div>
      </div>
    ),
  },
  {
    ask: "What are the basic installation requirements for the Primus Extension?",
    question: (
      <>
        The <a
          href={ZKAttestationLink}
          target="_blank"
          className={styles.questionLink}
        >
          Primus Extension
        </a> is currently compatible with Chrome and Microsoft Edge, and can be downloaded from the Chrome Web Store. 
      </>
    ),
  },
  {
    ask: "What is the data verification process?",
    question:
<>

Primus uses zkTLS to ensure web data authenticity, supported by independent research&nbsp;

       <a
          href="https://eprint.iacr.org/2023/964"
          target="_blank"
          className={styles.questionLink}
        >
          https://eprint.iacr.org/2023/964
        </a>
 , providing privacy-preserving data computation with integrity measures.

</>
  },
  {
    ask: "How does Primus ensure data security and privacy?",
    question:
      "With the Primus Extension, you retain full control over your data. Privacy settings are customizable, and your data remains isolated from smart contracts. The extension retrieves data solely for website logins, and all information is stored locally on your device, accessible only to you.",
  },
];

// const TutorialsLink = `${DocsLink}data-verification/primus-extension/mainfunctions/`;

const Card = ({ index, ask, question }) => {
  const [visible, setVisible] = useState(false);
  const [height, setHeight] = useState(0);
  const ref = useRef(null);
  const handleClick = () => {
    const newVal = !visible;
    setVisible(newVal);
    if (newVal) {
      const { height } = ref.current.getBoundingClientRect();
      setHeight(height || "auto");
    } else {
      setHeight(0);
    }
  };
  return (
    <div className={styles.card} onClick={handleClick}>
      <div className={styles.cardHeader}>
        <div className={styles.no}>0{index + 1}</div>
        <div
          className={cn(styles.btn, "flex mobile-view", {
            [styles.up]: visible,
          })}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="12"
            viewBox="0 0 20 12"
            fill="none"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M0.792893 1.04289C1.18342 0.652369 1.81658 0.652368 2.20711 1.04289L10 8.83579L17.7929 1.04289C18.1834 0.652368 18.8166 0.652368 19.2071 1.04289C19.5976 1.43342 19.5976 2.06658 19.2071 2.45711L10.7071 10.9571C10.3166 11.3476 9.68342 11.3476 9.29289 10.9571L0.792893 2.45711C0.402369 2.06658 0.402368 1.43342 0.792893 1.04289Z"
              fill="white"
            />
          </svg>
        </div>
      </div>
      <div className={styles.body}>
        <div
          className={cn(styles.ask, {
            [styles.visible]: visible,
          })}
        >
          {ask}
        </div>
        <div style={{ height }} className={cn(styles.question)}>
          {question}
        </div>
        <div ref={ref} className={cn(styles.question, styles.questionCalc)}>
          {question}
        </div>
      </div>
      <div
        className={cn(styles.btn, "pc-view", {
          [styles.up]: visible,
        })}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="12"
          viewBox="0 0 20 12"
          fill="none"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0.792893 1.04289C1.18342 0.652369 1.81658 0.652368 2.20711 1.04289L10 8.83579L17.7929 1.04289C18.1834 0.652368 18.8166 0.652368 19.2071 1.04289C19.5976 1.43342 19.5976 2.06658 19.2071 2.45711L10.7071 10.9571C10.3166 11.3476 9.68342 11.3476 9.29289 10.9571L0.792893 2.45711C0.402369 2.06658 0.402368 1.43342 0.792893 1.04289Z"
            fill="white"
          />
        </svg>
      </div>
    </div>
  );
};

export default () => {
  const ref = useRef();
  const [visible] = useFadeIn(ref);
  return (
    <div className={styles.root}>
      <SectionTitle
        ref={ref}
        visible={visible}
        transition
        className={styles.title}
      >
        Frequently asked questions
      </SectionTitle>
      <div className={styles.textLine}>
        <span className={styles.text}>Need more help? Join our</span>
        {/* <a target="_blank" href={TutorialsLink} className={styles.link}>
          Tutorials
        </a>
        <span className={styles.text}>&</span> */}
        <a target="_blank" href={DiscordLink} className={styles.link}>
          Discord
        </a>
      </div>
      <div className={styles.cardWrapper}>
        {data.map((item, index) => (
          <Card key={index} index={index} {...item} />
        ))}
      </div>
    </div>
  );
};
